import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-hero-carousel',
  templateUrl: './hero-carousel.component.html',
  styleUrls: ['./hero-carousel.component.css'],
})
export class HeroCarouselComponent implements AfterViewInit {
  @Input() data!: any;
  @Input() language!: string;
  @ViewChild('carousel') carousel!: ElementRef;
  navbarHeight: number = 0;
  constructor(private router: Router) {}
  ngAfterViewInit() {
    const navbar = document.querySelector('.navbar') as HTMLElement;

    if (navbar) {
      this.navbarHeight = navbar.offsetHeight;

      if (this.carousel) {
        (
          this.carousel.nativeElement as HTMLElement
        ).style.marginTop = `${this.navbarHeight}px`;
      }
    }
  }

  navigateWithQuery(fileName: string) {
    this.router.navigate([`/${this.language}/products`], {
      queryParams: { type: fileName },
    });
  }
}
